import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { CancelDispenserAgreementComponent } from './cancel-dispenser-agreement.component'

@NgModule({
  declarations: [CancelDispenserAgreementComponent],
  imports: [CommonModule, I18nModule, MatCardModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CancelDispenserAgreementComponent: {
          component: CancelDispenserAgreementComponent,
          guards: [UserPermissionsGuard]
        }
      }
    })
  ],
  exports: [CancelDispenserAgreementComponent]
})
export class CancelDispenserAgreementModule {}
